/**
 * @generated SignedSource<<cb878bb7cbdb1d3b336746eda8e2ffb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSprintGoalInput = {
  sprintId?: string | null;
  projectGroupSprintId?: string | null;
  description?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateSprintGoalMutation$variables = {
  input: CreateSprintGoalInput;
};
export type CreateSprintGoalMutation$data = {
  readonly createSprintGoal: {
    readonly sprintGoal: {
      readonly node: {
        readonly id: string;
        readonly description: string | null;
        readonly statusColor: string | null;
        readonly stage: string | null;
      } | null;
    } | null;
  } | null;
};
export type CreateSprintGoalMutation = {
  variables: CreateSprintGoalMutation$variables;
  response: CreateSprintGoalMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSprintGoalPayload",
    "kind": "LinkedField",
    "name": "createSprintGoal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SprintGoalTypeEdge",
        "kind": "LinkedField",
        "name": "sprintGoal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SprintGoal",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSprintGoalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSprintGoalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4fbeb9504a166bcee46aa031058bbf4",
    "id": null,
    "metadata": {},
    "name": "CreateSprintGoalMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSprintGoalMutation(\n  $input: CreateSprintGoalInput!\n) {\n  createSprintGoal(input: $input) {\n    sprintGoal {\n      node {\n        id\n        description\n        statusColor\n        stage\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "828794e9db73c9ed28c2cf9a89bbf63e";

export default node;
